import { useHistory } from "react-router-dom";
import { displayResultMessage } from "utils/misc";
import Form from "common/Form/Form";
import { LOGIN_PATH, MOBILE_SEARCH } from "common/constants";
import React, { useContext, useEffect } from "react";
import { AvoContext } from "analytics/AvoProvider";
import { PrimaryTitle } from "features/auth/styles";
import useMedia from "utils/hooks/useMedia";
import { PasswordSection } from "features/auth/PasswordSection";
import Button from "common/Buttons/Button";
import Link from "common/Typography/Link";
import styled from "styled-components";
import { sharedLib } from "@shared/services/shared.service";

interface Props {
  token: string;
}

const ResetPasswordForm = ({ token }: Props) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const [resetPassword, { isLoading }] =
    sharedLib.sharedApi.authentication.useResetPasswordMutation();
  const history = useHistory();
  const { avo } = useContext(AvoContext);

  useEffect(() => {
    avo?.resetPasswordView();
  }, [avo]);

  const onFinish = ({ password }: { password: string }) => {
    const args = {
      password,
      token,
    };
    displayResultMessage(
      resetPassword(args).unwrap(),
      "Password successfully updated! Proceed to login to your account.",
      "Reset password failed! Please try again later."
    ).then(() => history.push("/login"));
  };

  return (
    <Form
      name="login"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      layout="vertical"
      requiredMark={false}
      style={{ width: "100%" }}
    >
      <PrimaryTitle $isMobile={isMobile} style={{ marginBottom: 24 }}>
        Create New Password
      </PrimaryTitle>
      <PasswordSection
        size="large"
        showPlaceholder={false}
        showConfirm={true}
        passwordLabel={"New Password"}
      />
      <ButtonsWrapper>
        <Button
          type="primary"
          $size="l"
          htmlType="submit"
          loading={isLoading}
          style={{ width: "100%", margin: "12px 0" }}
        >
          Update Password
        </Button>
        <StyledLink onClick={() => history.push(LOGIN_PATH)}>Login</StyledLink>
      </ButtonsWrapper>
    </Form>
  );
};

export default ResetPasswordForm;

const ButtonsWrapper = styled.div`
  text-align: center;
`;
const StyledLink = styled(Link)`
  font-size: ${(p) => p.theme.typography.fontSizes.L};
`;
